import { cva } from '@/styled-system/css';

export const popoverArrowRecipe = cva({
  base: {
    fill: 'bg.elevated.mediumShadow',
  },
  variants: {
    modal: {
      true: {
        display: 'none',
      },
      false: {},
    },
    tone: {
      neutral: {},
      critical: {},
      info: {},
      success: {},
      warning: {},
    },
    placement: {
      top: {},
      bottom: {},
      left: {},
      right: {},
    },
    alignment: {
      start: {},
      end: {},
      center: {},
    },
  },
  compoundVariants: [
    // Critical tone arrow colors based on placement
    {
      tone: 'critical',
      placement: 'bottom',
      css: {
        // Use header color when arrow points to header area
        fill: 'Popover.Header.bg.critical',
      },
    },
    {
      tone: 'critical',
      placement: ['top', 'left', 'right'],
      css: {
        fill: 'bg.elevated.mediumShadow',
      },
    },
    {
      tone: 'info',
      placement: 'bottom',
      css: {
        // Use header color when arrow points to header area
        fill: 'Popover.Header.bg.info',
      },
    },
    {
      tone: 'info',
      placement: ['top', 'left', 'right'],
      css: {
        fill: 'bg.elevated.mediumShadow',
      },
    },
    {
      tone: 'success',
      placement: 'bottom',
      css: {
        // Use header color when arrow points to header area
        fill: 'Popover.Header.bg.success',
      },
    },
    {
      tone: 'success',
      placement: ['top', 'left', 'right'],
      css: {
        fill: 'bg.elevated.mediumShadow',
      },
    },
    {
      tone: 'warning',
      placement: 'bottom',
      css: {
        fill: 'Popover.Header.bg.warning',
      },
    },
    {
      tone: 'warning',
      placement: ['top', 'left', 'right'],
      css: {
        fill: 'bg.elevated.mediumShadow',
      },
    },
    {
      tone: 'critical',
      placement: ['left', 'right'],
      alignment: 'start',
      css: {
        // Use header color when arrow points to header area.
        fill: 'Popover.Header.bg.critical',
      },
    },
    {
      tone: 'info',
      placement: ['left', 'right'],
      alignment: 'start',
      css: {
        // Use header color when arrow points to header area.
        fill: 'Popover.Header.bg.info',
      },
    },
    {
      tone: 'success',
      placement: ['left', 'right'],
      alignment: 'start',
      css: {
        // Use header color when arrow points to header area.
        fill: 'Popover.Header.bg.success',
      },
    },
    {
      tone: 'warning',
      placement: ['left', 'right'],
      alignment: 'start',
      css: {
        // Use header color when arrow points to header area.
        fill: 'Popover.Header.bg.warning',
      },
    },
  ],
});
